/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const CloseIcon = ({ className }) => (
  <svg
    className={className}
    width="25px"
    height="25px"
    viewBox="0 0 400 400"
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M351.8 0l48 48-152 152 152 152-48 48-152-152-152 152-48-48 152-152L-.2 48l48-48 152 152 152-152z"
    />
  </svg>
);

export default CloseIcon;
